/** The BestOpen mark + wordmark. "Open" carries the brand gradient. */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="flex shrink-0 items-center gap-2">
      <img src="/icon.svg" alt="" width={size} height={size} style={{ width: size, height: size }} />
      <span
        className="font-display font-extrabold tracking-tight"
        style={{ fontSize: Math.round(size * 0.7), lineHeight: 1 }}
      >
        Best<span className="brand-text">Open</span>
      </span>
    </span>
  );
}
